// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    });
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();


// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
    // Selector de botones de color o select de variante
    const variantSelectors = document.querySelectorAll('.swatch input, .product__variants select');

    if (!variantSelectors.length) return; // Salir si no hay variantes

    // Todas las imágenes del producto
    const productImages = document.querySelectorAll('img[id^="Thumbnail-template"]');

    // Asignar automáticamente un índice de color a cada imagen
    productImages.forEach((img, idx) => {
        // Cada imagen recibe un "data-variant-index" según su orden
        img.setAttribute('data-variant-index', idx);
    });

    // Función para actualizar imágenes según el color seleccionado
    function updateImages(selectedIndex) {
        let currentVariant = parseInt(selectedIndex);
        if (isNaN(currentVariant)) currentVariant = 0;

        const imagesPerVariant = Math.ceil(productImages.length / variantSelectors.length);

        productImages.forEach((img, idx) => {
            const start = currentVariant * imagesPerVariant;
            const end = start + imagesPerVariant;
            if (idx >= start && idx < end) {
                img.style.display = 'block';
            } else {
                img.style.display = 'none';
            }
        });
    }

    // Detecta el cambio de variante
    variantSelectors.forEach((sel, i) => {
        sel.addEventListener('change', function (e) {
            let valueIndex = i;

            // Si es select, obtener el índice seleccionado
            if (sel.tagName.toLowerCase() === 'select') {
                valueIndex = sel.selectedIndex;
            }

            updateImages(valueIndex);
        });
    });

    // Mostrar la variante por defecto al cargar la página
    let defaultIndex = 0;
    const checked = document.querySelector('.swatch input:checked');
    if (checked) defaultIndex = Array.from(document.querySelectorAll('.swatch input')).indexOf(checked);
    else if (document.querySelector('.product__variants select')) defaultIndex = document.querySelector('.product__variants select').selectedIndex;

    updateImages(defaultIndex);
});

